// Картинка в картинці — спільне для плеєра ефіру і плеєра записів.
//
// Два різних API під однією кнопкою. Стандартний Picture-in-Picture
// (Chrome, Firefox, Edge, Safari на маку) і окремий шлях WebKit: на iPhone
// картинку в картинці надійно вмикає лише presentation mode самого <video>,
// а document.pictureInPictureEnabled там або відсутній, або є, але
// requestPictureInPicture мовчки відмовляє. Тому WebKit-шлях — першим.
//
// Перевіряємо не платформу, а наявність методів: у вбудованих вебв'ю
// (Telegram, застосунки) PiP часто вимкнено зовсім, і кнопка, яка нічого
// не робить, гірша за її відсутність

const webkitPipAvailable = (video) =>
  typeof video?.webkitSupportsPresentationMode === 'function' &&
  typeof video.webkitSetPresentationMode === 'function' &&
  video.webkitSupportsPresentationMode('picture-in-picture')

export const canUsePip = (video) =>
  !!video &&
  (webkitPipAvailable(video) ||
    (!!document.pictureInPictureEnabled && !video.disablePictureInPicture))

export const switchPip = async (video) => {
  if (!video) return
  try {
    if (webkitPipAvailable(video)) {
      video.webkitSetPresentationMode(
        video.webkitPresentationMode === 'picture-in-picture' ? 'inline' : 'picture-in-picture'
      )
      return
    }

    if (document.pictureInPictureElement) await document.exitPictureInPicture()
    else await video.requestPictureInPicture()
  } catch (e) {
    // Браузер міг відмовити (немає жесту користувача, відео ще без кадру) —
    // тоді просто лишаємось у звичайному режимі: кнопку видно, її натиснуть
    // ще раз
  }
}
